import { render, staticRenderFns } from "./wechat-moments.vue?vue&type=template&id=2af1f4a8&scoped=true"
import script from "./wechat-moments.vue?vue&type=script&lang=js"
export * from "./wechat-moments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af1f4a8",
  null
  
)

export default component.exports